// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"768e1df2","257":"4ac765df","576":"574bd899","841":"b749842a","886":"e7265546"}[chunkId] + ".chunk.css";
};